"use client";

import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";

export function AnalyticsTracking() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const hasScrolled75 = useRef(false);

  // Track Page Views
  useEffect(() => {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "pageview",
        page: pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : ""),
      });
    }
  }, [pathname, searchParams]);

  // Track Scroll Depth (75%)
  useEffect(() => {
    const handleScroll = () => {
      if (hasScrolled75.current) return;

      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      const scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;

      const scrolledPercentage = ((scrollTop + clientHeight) / scrollHeight) * 100;

      if (scrolledPercentage >= 75) {
        hasScrolled75.current = true;
        if (typeof window !== "undefined" && window.dataLayer) {
          window.dataLayer.push({
            event: "scroll_75",
            page: pathname
          });
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    // Reset ref on page change if needed, but usually scroll depth is per page session
    // For SPA, we might want to reset it on pathname change
    hasScrolled75.current = false;

    return () => window.removeEventListener("scroll", handleScroll);
  }, [pathname]);

  return null;
}
